import AjaxClass from './../Forms/Validation/ajaxClass.js';

export default function changeArea(){
    class ChangeArea extends AjaxClass {
        successFunction() {
            let urlCurrent = $("#homeUrl").val();
            window.location.replace(urlCurrent);    
        }
    }

    $("[changeArea]").on('click', function (e) {
        e.preventDefault();
        let area = $(this).attr('changeArea');
        let url = $("#changeAreaUrl").val();

        let changeArea = new ChangeArea(null, 'POST', url, 'json', null);
        changeArea.dataString = 'area=' + area;
        changeArea.sendNoRecaptcha();
    });

    $("#trilha-area-home").on('change', function (e) {
        let area = $(this).val();
        let url = "";

        let changeArea = new FilterTrilhas(null, 'POST', url, 'html', null);
        changeArea.dataString = 'area=' + area;
        changeArea.sendNoRecaptcha();
    });

    class FilterTrilhas extends AjaxClass {
        successFunction(html) {
            $("body").css({"opacity" : "1"});
            $("#cardsDiv").html(html);
        }
    
        beforeSendFunction() {
            $("body").css({"opacity" : "0.5"});
        };
    
        errorFunction(error) {
            $("body").css({"opacity" : "1"});
            console.log(error.responseText);
            
            alert('Ocorreu um erro ao atualizar as Trilhas! Tente novamente mais tarde');
        };
    }
}
